<template>
    <span class="badge" :class="classOutput">{{textOutput}}</span>
</template>
<script>
    export default{
        props: {
            value: null
        },
        computed: {
            classOutput: function(){
                if(this.value){
                    return 'badge-success'
                }else{
                    return 'badge-danger'
                }
            },
            textOutput: function(){
                if(this.value){
                    return this.$t('global.Yes')
                }else{
                    return this.$t('global.No')
                }
            }
        }
    }
</script>
